const btns = document.querySelectorAll('.play-btn')

;[...btns].forEach(btn => {
  btn.addEventListener('click', e => {
    document.body.classList.add('playing')
    const player = document.querySelector(btn.dataset.player)

    if (player) {
      player.src = player.dataset.src
    }
  })
})
